// removed by extract-text-webpack-plugin
module.exports = {"project_navbar":"project_navbar","newProject":"newProject","project_navbar_dropdown":"project_navbar_dropdown","project_navbar_dropdown_wrapper":"project_navbar_dropdown_wrapper","project_navbar_header":"project_navbar_header","project_navbar_row":"project_navbar_row","project_badge_wrapper":"project_badge_wrapper","project_badge":"project_badge","project_badge_row":"project_badge_row","dark":"dark","ant-dropdown-menu":"ant-dropdown-menu"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Project/components/ProjectNavbar/style.scss
// module id = 1350
// module chunks = 0